import React from "react";
import { CrossSVG, FlagSVG, TickSVG } from "../../assets/svgs";

const QuestioNumber = ({
  questionId,
  isFlagged,
  value,
  onClick,
  index,
  ans,
  currentIndex,
}) => {
  const isSelected = currentIndex === index;
  let classes = "buttonQuiz buttonQuiz-round qst-btn";
  if (isSelected) {
    classes = classes + " selected-question";
  } else if (ans === true) {
    classes = classes + " correct-ans";
  } else if (ans === false) {
    classes = classes + " incorrect-ans";
  } else if (isFlagged) {
    classes = classes + " set-color-flag";
  } else {
    classes = classes + "";
  }
  return (
    <div key={questionId} className="question-item">
      <button onClick={onClick} type="button" className={classes}>
        {value}
        {isFlagged ? (
          <FlagSVG />
        ) : ans === false ? (
          <CrossSVG />
        ) : ans === true ? (
          <TickSVG />
        ) : (
          ""
        )}
      </button>
    </div>
  );
};

export default QuestioNumber;
